

(function popupModuleDefinition() {

    angular.module('Popup', ['ui.bootstrap.position']);

})();